// src/Saga/books.js
import {call, takeLatest} from 'redux-saga/effects';
import {actions as booksActions, types as booksTypes} from '../Ducks/books';
import {callApi} from './utils';
import * as api from '../API/books';

function* getBooks(action) {
    const {success, failure} = booksActions.saga.getBooks;
    yield callApi(call(api.getBooks, action.data), success, failure);
}

function* getBookDetails(action) {
    const {success, failure} = booksActions.saga.getBookDetails;
    yield callApi(call(api.getBookDetails, action.data), success, failure);
}

function* createBook(action) {
    const {success, failure} = booksActions.saga.createBook;
    yield callApi(call(api.createBook, action.data), success, failure);
}

function* updateBook(action) {
    const {success, failure} = booksActions.saga.updateBook;
    yield callApi(call(api.updateBook, action.data), success, failure);
}

function* bulkImportBooks(action) {
    const {success, failure} = booksActions.saga.bulkImportBooks;
    yield callApi(call(api.bulkImportBooks, action.data.file), success, failure);
}

function* archiveBook(action) {
    const {success, failure} = booksActions.saga.archiveBook;
    yield callApi(call(api.archiveBook, action.data.id), success, failure);
}

function* restoreBook(action) {
    const {success, failure} = booksActions.saga.restoreBook;
    yield callApi(call(api.restoreBook, action.data.id), success, failure);
}

export default function* rootBooksSaga() {
    yield takeLatest(booksTypes.getBooks, getBooks);
    yield takeLatest(booksTypes.getBookDetails, getBookDetails);
    yield takeLatest(booksTypes.createBook, createBook);
    yield takeLatest(booksTypes.updateBook, updateBook);
    yield takeLatest(booksTypes.bulkImportBooks, bulkImportBooks);
    yield takeLatest(booksTypes.archiveBook, archiveBook);
    yield takeLatest(booksTypes.restoreBook, restoreBook);
}
